module.exports = __webpack_public_path__ + "media/images/SinodaLogo-16a6eb4b.png";